<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <!-- <vx-tooltip class="position-icon" :text="$t('attendance.detailCheck')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="showDetail"/>
            </vx-tooltip> -->

            <vx-tooltip class="position-icon" :text="$t('attendance.approve')" position="top" v-if="!params.data.status && isPermissionAccept()">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="confirmUpdateRecord"/>
            </vx-tooltip>
            <vx-tooltip class="position-icon" :text="$t('attendance.delete')" position="top" v-if="!params.data.status && isPermissionAccept()">
                <feather-icon icon="TrashIcon" class="text-danger icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import {isAPI, isRouter} from "../../../../store/permission"
import {constAPI, constRouter} from "../../../../store/constant"

export default {
    name: 'CellRendererActions',
    methods: {
        isPermissionAccept() {
            return isAPI(this, constAPI.attendence_accept)
        },
        // showDetail() {
        //     this.$router.push(`/user/time-keeping-detail?branch_id=${this.params.data.branchId}&id=${this.params.data.employeeId}`).catch(() => {
        //     })
        // },

        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận điểm danh`,
                text: `Bạn có chắc muốn xoá điểm danh cho ${this.params.data.fullName} không?`,
                accept: this.deleteRecord,
                acceptText: "Có",
                cancelText: "Không"
            })
        },

        deleteRecord() {
            let id = this.params.data.id;
            this.$crm.post(`employee-workshift-by-day/delete-student/${id}`).then(() => {
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', true);
                return this.$vs.notify({
                    text: 'Xoá thành công lịch dạy',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        confirmUpdateRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận điểm danh`,
                text: `Bạn có chắc muốn điểm danh cho ${this.params.data.fullName} không?`,
                accept: this.verify,
                acceptText: "Có",
                cancelText: "Không"
            })
        },
        verify() {
            let formData = {
                "employeeId": this.params.data.employeeId,
                "createdAt": this.params.data.workStartAt,
                "imageUrl": null,
                teachingScheduleId: this.params.data.teachingScheduleId
            }
            this.$crm.post('/time-keeping/update-time-keeping', formData).then((res) => {
                if (res.data) {
                    this.showVerifySuccess();
                } 
                else {
                    this.showVerifyErr();
                }
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showVerifySuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xác nhận thành công.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        showVerifyErr() {
            return this.$vs.notify({
                text: "Thời gian không nằm trong khoảng thời gian chấm công.",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
    }
}
</script>
<style scoped>

</style>

